import { Children, isValidElement } from 'react';
import { DataSourceContext } from './DataSourceContext';
import { jsx as _jsx } from "react/jsx-runtime";
function DataSources({
  children,
  ownerId
}) {
  const dataSources = Children.toArray(children).filter(isValidElement);
  return /*#__PURE__*/_jsx("div", {
    id: listboxId(ownerId),
    role: "listbox",
    "aria-multiselectable": "false",
    children: dataSources.map((child, index) => /*#__PURE__*/_jsx(DataSourceContext.Provider, {
      value: {
        index
      },
      children: child
    }, index))
  });
}
export const listboxId = ownerId => `listbox-${ownerId}`;
export default DataSources;